export default __webpack_public_path__ + "static/media/PLANET4_logo_4_Colored.a2c4919a.png";